import { lazy } from 'react';
import Loadable from 'components/Loadable';
import DefaultLayout from 'layout/Default';
import { ProtectedRoute } from 'routes/RouteGuards';

const UpdateLicensePage = Loadable(
  lazy(() => import('views/licenses/UpdateLicense'))
);

const LicensesRoutes = {
  path: '/update-license',
  element: <ProtectedRoute />,
  children: [
    {
      element: <DefaultLayout />,
      children: [
        {
          index: true,
          element: <UpdateLicensePage />
        }
      ]
    }
  ]
};

export default LicensesRoutes;
